import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { AuthService } from '../services';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    let clonedReq = req;
    // Identify the client channel to the API only (third-party hosts would
    // fail CORS preflight on the custom header). The API uses it for
    // org-level web read-only mode (org_config.enforce_read_only_web).
    if (req.url.startsWith(environment.API_ENDPOINT)) {
      const setHeaders: Record<string, string> = { 'x-device': 'web' };
      if (this.authService.isLoggedIn()) {
        const user = this.authService.getCurrentUser();
        if (user.token) {
          setHeaders.token = user.token;
        }
      }
      clonedReq = req.clone({ setHeaders });
    }

    // Guest requests (guest-action endpoints + guest attachment uploads carrying a gac code)
    // use 401 for OTP challenges; let callers handle those instead of redirecting to login
    const isGuestRequest = req.url.includes('/v1/guest-action/') || /[?&]gac=/.test(req.urlWithParams);

    return next.handle(clonedReq).pipe(
      catchError(err => {

        if (err.status === 401 && !isGuestRequest) {
          this.authService.clearCurrentUser();
          this.router.navigate(['/login']);
          // Todo add returnUrl
        }

        return throwError(() => err);
      })
    );
  }
}
